import React from 'react';

export default class InfoTile extends React.Component {
  render() {
    return (
      <div
        className={`info-tile ${this.props.visible ? 'visible' : ''}`}
        style={{ backgroundColor: this.props.backgroundColor || '#f7f7f7' }}
      >
        {!this.props.cantClose && (
          <div className="info-tile-close" onClick={this.props.onClose}>
            <i className="fa fa-times" />
          </div>
        )}
        <div className="info-tile-text">{this.props.text}</div>
      </div>
    );
  }
}
